import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/sections/Hero";
import { WhatYouGet } from "./components/sections/WhatYouGet";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { PainPoints } from "./components/sections/PainPoints";
import { Volumes } from "./components/sections/Volumes";
import { Toolkit } from "./components/sections/Toolkit";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="w-full overflow-x-hidden bg-ink-950 font-sans" data-id="element-0" data-mp="23ti864kkyuk7">
      <MetaPixel data-id="element-1" data-mp="3ijfvu1ti80fo" />
      <Hero data-id="element-2" data-mp="3ihv2gfixenje" />
      <main data-id="element-3" data-mp="3ii4qhxkeukmg">
        <WhatYouGet data-id="element-4" data-mp="3mlavl1vse5rc" />
        <BeforeAfter data-id="element-5" data-mp="3mkrc3gqhn9b7" />
        <PainPoints data-id="element-6" data-mp="3mk83wrqn3zad" />
        <Volumes data-id="element-7" data-mp="3mjgannkimdn9" />
        <Toolkit data-id="element-8" data-mp="3rc9du70c5dx8" />
        <Bonuses data-id="element-9" data-mp="3rbra6pbcfxfa" />
        <Offer data-id="element-10" data-mp="3rdapodp6e4g0" />
        <Guarantee data-id="element-11" data-mp="3rcsxpt9jqcdw" />
        <Testimonials data-id="element-12" data-mp="3recdzjv7cnfo" />
        <Author data-id="element-13" data-mp="5yhgo69t1c8" />
        <Faq data-id="element-14" data-mp="6hq1ea16ddl" />
        <FinalCta data-id="element-15" data-mp="4wv3njt0sf7" />
      </main>
      <FloatingCta data-id="element-16" data-mp="56m9egl55mh" />
      <PurchasePopup data-id="element-17" data-mp="7stte3h7l4p" />
    </div>;
}